import { useEffect, useState } from 'react';
import { ReactComponent as StarIcon } from '$icons/uncolored/star.svg';
import { ReactComponent as FilledStarIcon } from '$icons/uncolored/filledStar.svg';

interface Props {
  videoRating: number;
  setVideoRating: (ind: number) => void;
}

const SPKEmployerCandidateVideosRate = ({
  videoRating,
  setVideoRating,
}: Props) => {
  const [hoverIndex, setHoverIndex] = useState(videoRating || -1);

  useEffect(() => {
    setHoverIndex(videoRating);
  }, [videoRating]);

  const stars = Array.from({ length: 5 }, (item, index) => {
    if (index <= hoverIndex) {
      return (
        <FilledStarIcon
          key={index}
          width="24px"
          height="24px"
          onMouseEnter={() => setHoverIndex(index)}
          onClick={() => setVideoRating(index)}
          className="fill-employer-primary"
        />
      );
    }

    return (
      <StarIcon
        key={index}
        width="24px"
        height="24px"
        onMouseEnter={() => setHoverIndex(index)}
        onClick={() => setVideoRating(index)}
        className="fill-employer-primary"
      />
    );
  });
  return (
    <div
      className="flex flex-row gap-2"
      onMouseLeave={() => setHoverIndex(videoRating)}
    >
      {stars}
    </div>
  );
};

SPKEmployerCandidateVideosRate.defaultProps = {
  candidateId: undefined,
};

export default SPKEmployerCandidateVideosRate;
